import type LocationDto from "../../../../dto/construction/details/LocationDto";
import type MetadataDto from "../../../../dto/construction/details/MetadataDto";
import type SpecificationDto from "../../../../dto/construction/details/SpecificationDto";
import type CalculationParametersDto from "../../../../dto/construction/details/CalculationParametersDto";
import type MastFeaturesDto from "../../../../dto/construction/parts/MastFeaturesDto";
import type MastDto from "../../../../dto/construction/parts/MastDto";
import type BeamDto from "../../../../dto/construction/parts/BeamDto";
import type CatenaryDto from "../../../../dto/construction/parts/CatenaryDto";
import type CatenarySuspensionDto from "../../../../dto/construction/parts/CatenarySuspensionDto";
import type CrossBeamDto from "../../../../dto/construction/parts/CrossBeamDto";
import type DeviceDto from "../../../../dto/construction/parts/DeviceDto";
import type FootplateDto from "../../../../dto/construction/parts/FootplateDto";
import type FoundationDto from "../../../../dto/construction/parts/FoundationDto";
import type HingedCantileverDto from "../../../../dto/construction/parts/HingedCantileverDto";
import type MastCoordinatesDto from "../../../../dto/construction/parts/MastCoordinatesDto";
import type RegistrationArmDto from "../../../../dto/construction/parts/RegistrationArmDto";
import type SpanInfoDto from "../../../../dto/construction/parts/SpaninfoDto";
import type SteadyArmDto from "../../../../dto/construction/parts/SteadyArmDto";
import type SupportArmDto from "../../../../dto/construction/parts/SupportArmDto";
import type WireDto from "../../../../dto/construction/parts/WireDto";
import type WireSuspensionDto from "../../../../dto/construction/parts/WireSuspensionDto";

type TableData =
  | LocationDto
  | MetadataDto
  | SpecificationDto
  | CalculationParametersDto
  | BeamDto
  | CatenaryDto
  | CatenarySuspensionDto
  | CrossBeamDto
  | DeviceDto
  | FootplateDto
  | FoundationDto
  | HingedCantileverDto
  | MastCoordinatesDto
  | MastDto
  | MastFeaturesDto
  | RegistrationArmDto
  | SpanInfoDto
  | SteadyArmDto
  | SupportArmDto
  | WireDto
  | WireSuspensionDto;

interface ConstructionTableProps {
  constructionId: string;
  constructionElementsName: string;
  constructionPartItems: TableData[];
  isAccepted: boolean;
}

interface ConstructionTableHeaderProps {
  constructionElementsName: string;
  constructionElementPropertyHeaders: string[];
}

interface ConstructionTableHeaderCellProps {
  constructionElementsName: string;
  constructionElementPropertyHeader: string;
}

interface ConstructionTableBodyProps {
  constructionId: string;
  constructionElementsName: string;
  constructionPartItems: TableData[];
  isAccepted: boolean;
}

interface ConstructionTableRowProps {
  constructionId: string;
  constructionElementsName: string;
  constructionPartItem: TableData;
  isAccepted: boolean;
  renderEmpty?: boolean;
  extraInfo?: { family: string }
}

const exceptionCells: string[] = [
  "id",
  "catenaryId",
  "hingedCantileverId",
  "registrationArmId",
  "mastId",
  "beamId",
  "footplateId",
  "supportArmId",
  "deviceId",
  "crossBeamId",
  "isAccepted",
  "isSelected",
  "parentId",
  "matCrossSpanWire",
  "associatedMasts",
  "associatedCrossBeams",
  "associatedSupportArms",
  "attachedCrossBeams",
];

export {
  type TableData,
  type ConstructionTableProps,
  type ConstructionTableHeaderProps,
  type ConstructionTableHeaderCellProps,
  type ConstructionTableBodyProps,
  type ConstructionTableRowProps,
  exceptionCells,
};
